import React, {FC, useRef, useState} from 'react'
import {showErrorToast} from '../../../../shared/components/ToastUtils'
import {apiErrorMessage, publicDocumentUrl} from '../../public/PublicModels'
import {ImageCategory, uploadCompanyImage} from './Api'

const ACCEPTED_TYPES = ['image/png', 'image/jpeg', 'image/webp']
const MAX_SIZE = 5 * 1024 * 1024

type Props = {
  category: ImageCategory
  documentId: string
  onChange: (documentId: string) => void
  /** LOGO: yuvarlak önizleme, HEADER: geniş bant */
  variant: 'logo' | 'header'
  hint: string
}

/** Seçilen görsel hemen MinIO'ya yüklenir; dönen id profil kaydedilince firmaya bağlanır */
export const ImageUploadField: FC<Props> = ({category, documentId, onChange, variant, hint}) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [uploading, setUploading] = useState(false)
  const imageUrl = publicDocumentUrl(documentId)

  const handleFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    event.target.value = ''
    if (!file) return
    if (!ACCEPTED_TYPES.includes(file.type) || file.size > MAX_SIZE) {
      showErrorToast('PNG, JPG veya WEBP formatında en fazla 5MB görsel seçiniz')
      return
    }
    setUploading(true)
    try {
      const {data} = await uploadCompanyImage(file, category)
      onChange(data.payload.id)
    } catch (error) {
      showErrorToast(apiErrorMessage(error, 'Görsel yüklenemedi'))
    } finally {
      setUploading(false)
    }
  }

  const previewStyle: React.CSSProperties =
    variant === 'logo'
      ? {width: 120, height: 120, borderRadius: '50%'}
      : {width: '100%', height: 160, borderRadius: 12}

  return (
    <div className='d-flex flex-column gap-3'>
      <div
        className='d-flex align-items-center justify-content-center bg-light border border-dashed border-gray-300 overflow-hidden'
        style={previewStyle}
      >
        {uploading ? (
          <span className='spinner-border text-primary' />
        ) : imageUrl ? (
          <img
            src={imageUrl}
            alt=''
            style={{width: '100%', height: '100%', objectFit: variant === 'logo' ? 'contain' : 'cover'}}
          />
        ) : (
          <i className='bi bi-image fs-2x text-gray-400'></i>
        )}
      </div>
      <div className='d-flex align-items-center gap-2'>
        <button
          type='button'
          className='btn btn-sm btn-light-primary'
          disabled={uploading}
          onClick={() => inputRef.current?.click()}
        >
          <i className='bi bi-upload'></i>
          {imageUrl ? 'Değiştir' : 'Yükle'}
        </button>
        {imageUrl && (
          <button type='button' className='btn btn-sm btn-light' onClick={() => onChange('')}>
            Kaldır
          </button>
        )}
      </div>
      <div className='form-text mt-0'>{hint}</div>
      <input
        ref={inputRef}
        type='file'
        accept={ACCEPTED_TYPES.join(',')}
        className='d-none'
        onChange={handleFile}
      />
    </div>
  )
}
